import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3" }
const _hoisted_5 = { class: "default-table-area style-two to-do-list padding-style" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { class: "text-body" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = {
  class: "position-relative top-2 ms-1",
  for: "flexCheckDefault12"
}
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "text-body" }
const _hoisted_13 = { class: "d-flex align-items-center gap-1" }
const _hoisted_14 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_15 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_16 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_17 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_18 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_19 = { class: "material-symbols-outlined fs-16 text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mb-0" }, "To Do List", -1)),
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search here",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("div", { class: "form-check" }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: "",
                      id: "flexCheckDefault7"
                    }),
                    _createElementVNode("label", {
                      class: "position-relative top-2 ms-1",
                      for: "flexCheckDefault7"
                    }, " ID ")
                  ])
                ]),
                _createElementVNode("th", { scope: "col" }, "Task Title"),
                _createElementVNode("th", { scope: "col" }, "Assigned To"),
                _createElementVNode("th", { scope: "col" }, "Due Date"),
                _createElementVNode("th", { scope: "col" }, "Priority"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems.slice(0, 5), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[4] || (_cache[4] = _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: "",
                        id: "flexCheckDefault12"
                      }, null, -1)),
                      _createElementVNode("label", _hoisted_10, _toDisplayString(item.id), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/project-management/project-overview",
                      class: "text-body"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.taskTitle), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.assignedTo), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.dueDate), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.priority), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                    }, _toDisplayString(item.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", _hoisted_14, [
                        _createElementVNode("i", _hoisted_15, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_16, [
                        _createElementVNode("i", _hoisted_17, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_18, [
                        _createElementVNode("i", _hoisted_19, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "p-4 text-end" }, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary text-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
            "data-bs-toggle": "offcanvas",
            "data-bs-target": "#toDoListModal",
            "aria-controls": "toDoListModal"
          }, [
            _createElementVNode("span", { class: "py-sm-1 d-block" }, [
              _createElementVNode("i", { class: "ri-add-line me-1" }),
              _createElementVNode("span", null, "Add New Task")
            ])
          ])
        ], -1))
      ])
    ])
  ]))
}